/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 8/25/20
 *
 */

const AssignToData = [
	{label: "Client", value: "client"},
	{label: "Coach", value: "coach"},
]
const AssignToOptions = Object.freeze({
	COACH: 'coach',
	CLIENT: 'client',
})

export {
	AssignToData,
	AssignToOptions
}

